import {
  Button,
  Container,
  CssBaseline,
  TextField,
  Typography,
  Fade,
  Grow,
  LinearProgress,
  Link
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import ColorModeContext from "../../layout/themeContext";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  header: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    padding: theme.spacing(4, 8),
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      justifyContent: 'center',
    }
  },
  navLink: {
    color: '#1c1e21',
    fontWeight: 600,
    textTransform: 'none',
    fontSize: '0.95rem',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
      opacity: 0.8
    }
  },
  container: {
    maxWidth: '400px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  title: {
    fontWeight: 800,
    fontSize: '2rem',
    color: theme.palette.primary.main, // Removido gradiente, usando cor whitelabel
    marginBottom: theme.spacing(3),
  },
  subText: {
    color: '#65676b',
    fontSize: '1rem',
    marginBottom: theme.spacing(4),
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  inputRounded: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
      backgroundColor: '#f5f6f7',
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: '1px solid #ccc',
      },
      '&.Mui-focused fieldset': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
      '& input': {
        padding: '16.5px 14px',
        textAlign: 'center',
      },
    },
  },
  submitButton: {
    borderRadius: '30px',
    padding: '12px',
    fontSize: '1rem',
    fontWeight: 'bold',
    textTransform: 'none',
    boxShadow: 'none',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      boxShadow: 'none',
    },
    position: 'relative',
    overflow: 'hidden',
  },
  linkBack: {
    marginTop: theme.spacing(2),
    fontWeight: 500,
    color: theme.palette.primary.main,
    textDecoration: 'none',
    cursor: 'pointer',
    fontSize: '0.95rem',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  loadingBar: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '4px',
  },
}));

const EsqueciSenha = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [visivel, setVisivel] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const { colorMode } = useContext(ColorModeContext);

  React.useEffect(() => {
    setVisivel(true);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setEnviando(false);
      setEnviado(true);
      toast.success("Link de redefinição de senha enviado com sucesso");
      setTimeout(() => setEnviado(false), 2000);
    } catch (err) {
      setEnviando(false);
      toastError(err);
    }
  };

  const handleHelpClick = () => {
    const message = "Olá, gostaria de solicitar suporte técnico.";
    const phone = "5531983618392";
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className={classes.root}>
      <CssBaseline />

      {/* Header com Central de Ajuda */}
      <div className={classes.header}>
        <div className={classes.navLink} onClick={handleHelpClick}>
          Central de Ajuda
        </div>
      </div>

      <Fade in={visivel} timeout={1000}>
        <Container className={classes.container}>
          <Grow in={visivel} timeout={1200}>
            <div>
              <Typography variant="h4" className={classes.title}>
                Redefinir senha
              </Typography>

              <Typography className={classes.subText}>
                Informe o e-mail associado à sua conta e enviaremos um link para resetar sua senha.
              </Typography>

              <form className={classes.form} noValidate onSubmit={handleSubmit}>
                <TextField
                  variant="outlined"
                  placeholder="Digite seu e-mail"
                  fullWidth
                  id="email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={classes.inputRounded}
                  disabled={enviando}
                  InputProps={{
                    startAdornment: null
                  }}
                />

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  className={classes.submitButton}
                  disabled={enviando || enviado}
                >
                  {enviando ? "Enviando..." : enviado ? "E-mail Enviado!" : "Enviar link de redefinição"}
                  {enviando && (
                    <LinearProgress className={classes.loadingBar} />
                  )}
                </Button>

                <Link
                  component={RouterLink}
                  to="/login"
                  className={classes.linkBack}
                >
                  Voltar ao Login
                </Link>

              </form>
            </div>
          </Grow>
        </Container>
      </Fade>
    </div>
  );
};

export default EsqueciSenha;
